import { helper } from '@ember/component/helper';

import { toArray } from 'rise-ui/utils/array.js';

export default helper(function recordsWithResultHelper([ records ]) {
  return records?.filter?.(record => {
    const items = toArray(record.validItems);
    return items.length && items.some(item => item.temporalStartDate);
  });
});
